/* eslint-disable no-else-return */
/* eslint-disable no-lonely-if */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Styles from './index.module.css';

const Categories = {
  Poor: 'poor',
  Mediocre: 'mediocre',
  Good: 'good',
};

const CategoryStrings = {
  [Categories.Poor]: '不佳',
  [Categories.Mediocre]: '維持',
  [Categories.Good]: '良好',
};

const Indicators = {
  [Categories.Poor]: '⬇',
  [Categories.Mediocre]: '―',
  [Categories.Good]: '⬆',
};

// const ratingToCategory = (rating) => {
//   if (rating < 0) return Categories.Poor;
//   if (rating < 20) return Categories.Mediocre;
//   return Categories.Good;
// };

const ratingCategoryIdentifier = (rating, value) => {
  if (rating < -value) {
    return Categories.Poor;
  } else if (rating >= -value && rating <= value) {
    return Categories.Mediocre;
  } else {
    return Categories.Good;
  }
};

const ratingToCategory = (rating, title) => (title === '客單表現' ? ratingCategoryIdentifier(rating, 15) : ratingCategoryIdentifier(rating, 1));

export default function RatingCard({
  rating,
  title,
  measure,
  icon,
}) {
  const category = ratingToCategory(rating, title);
  return (
    <div
      className={classNames(
        Styles.mainContainer,
        {
          [Styles.mainContainerGood]: category === Categories.Good,
          [Styles.mainContainerMediocre]: category === Categories.Mediocre,
          [Styles.mainContainerPoor]: category === Categories.Poor,
        },
      )}
    >
      <div className={Styles.iconContainer}><img style={{ width: '40px' }} src={icon} alt="Icon" /></div>
      <div className={Styles.messageContainer}>{`${title}${CategoryStrings[category]}`}</div>
      <div className={Styles.measureContainer}>{measure}</div>
      <div className={Styles.rateContainer}>{`${rating === 0 ? '資料不足' : `${rating > 0 ? `+${rating.toFixed(2)}` : rating.toFixed(2)}%`}`}</div>
      <div
        className={classNames(
          Styles.indicatorContainer,
          {
            [Styles.indicatorContainerGood]: category === Categories.Good,
            [Styles.indicatorContainerMediocre]: category === Categories.Mediocre,
            [Styles.indicatorContainerPoor]: category === Categories.Poor,
          },
        )}
      >
        {Indicators[category]}
      </div>
    </div>
  );
}

RatingCard.propTypes = {
  rating: PropTypes.number,
  title: PropTypes.string,
  measure: PropTypes.string,
  icon: PropTypes.node,
};

RatingCard.defaultProps = {
  rating: 0,
  title: '',
  measure: '',
  icon: null,
};
